import type { WeeklyPlanRow } from "../../../shared/weekly-planning";

export type WeeklyPlanningRowScope = "ISSUES" | "ALL";

export function rowLineName(row: WeeklyPlanRow) {
  return row.lineId
    ? row.lineName
    : row.source?.sourceLineName || "Hat eşleşmesi gerekli";
}

export function rowIssueLabel(row: WeeklyPlanRow) {
  const missing = new Map([
    ["lineId", "hat"],
    ["productCode", "ürün kodu"],
    ["quantity", "miktar"],
    ["unit", "birim"],
    ["capacityPerHour", "saatlik kapasite"],
    ["durationHours", "süre"],
    ["sourceValidation", "kaynak doğrulaması"],
  ]);
  const fields = (row.missingFields ?? []).map(
    (field) => field === "workOrderIdentity"
      ? row.kind === "ACTIVITY" ? "Etkinlik; üretim kuyruğuna aktarılmaz" : "Mikro iş emri doğrulaması"
      : missing.get(field) ?? field,
  );
  return fields.join(" · ");
}

function normalized(value: string | null | undefined) {
  return (value ?? "").toLocaleLowerCase("tr-TR").replace(/\s+/gu, "");
}

export function filteredWeeklyPlanRows(
  rows: WeeklyPlanRow[],
  scope: WeeklyPlanningRowScope,
  lineName: string,
  query: string,
) {
  const needle = normalized(query.trim());
  return rows.filter((row) => {
    if (scope === "ISSUES" && (row.state ?? "READY") === "READY") return false;
    if (lineName && rowLineName(row) !== lineName) return false;
    if (!needle) return true;
    return [
      row.productName,
      row.productCode,
      row.workOrderNo,
      rowLineName(row),
      row.source?.sourceRow?.toString(),
    ].some((value) => normalized(value).includes(needle));
  });
}

export function paginatedWeeklyPlanRows(
  rows: WeeklyPlanRow[],
  page: number,
  pageSize = 25,
) {
  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));
  const currentPage = Math.min(Math.max(page, 1), totalPages);
  return {
    currentPage,
    totalPages,
    rows: rows.slice((currentPage - 1) * pageSize, currentPage * pageSize),
  };
}
